const CRM_SOURCE_ROUTES = /^\/(?:emails|tasks|meetings|companies|contacts|deals|leads|files|branches|brands|synergies|calendar)(?:\/|$)/;

/** Persisted state is untrusted: citations open browser pages, never API JSON. */
export function safeMartinaSourceHref(value: unknown): string | null {
  if (typeof value !== 'string' || !value || value !== value.trim() || /[\u0000-\u0020\u007f\\]/.test(value)) return null;
  try {
    const local = value.startsWith('/') && !value.startsWith('//');
    if (!local && !value.startsWith('https://')) return null;
    const url = new URL(value, 'https://martina.invalid');
    if (url.protocol !== 'https:' || url.username || url.password) return null;
    // Decode once to catch encoded API paths; reject residual escapes to prevent
    // a second decoding layer turning an apparently safe route into another path.
    const path = decodeURIComponent(url.pathname);
    if (/[\\%\u0000-\u0020\u007f]/.test(path) || /(?:^|\/)\.\.(?:\/|$)/.test(path) || /^\/api(?:\/|$)/i.test(path)) return null;
    if (local && !CRM_SOURCE_ROUTES.test(path)) return null;
    return local ? `${url.pathname}${url.search}${url.hash}` : url.href;
  } catch {
    return null;
  }
}

